import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';

import { MainLayout } from 'components/Layouts';
import PreQualificationProcess from 'pages/PreQuilificationProcess';
import CreditScoreDisclosure from 'pages/CreditScoreDisclosure';
import ApplicationProcess from 'pages/ApplicationProcess';
import SignInPage from 'pages/SignInPage';

import OktaController from 'components/Auth/OktaController';
import RequiredAuth from 'components/Auth/RequireAuth';
import { env } from 'env';
import TilaBoxPage from 'pages/TilaBoxPage';

export default () => {
  return (
    <Routes>
      <Route element={<OktaController />}>
        <Route element={<MainLayout />}>
          <Route path={`${env.REACT_APP_BASE_URL}/login`} element={<SignInPage />} />
          <Route path={`${env.REACT_APP_BASE_URL}/prequalification`} element={<PreQualificationProcess />} />
          <Route path={`${env.REACT_APP_BASE_URL}/callback`} element={<LoginCallback />} />
          <Route element={<RequiredAuth />}>
            <Route path={`${env.REACT_APP_BASE_URL}`} element={<ApplicationProcess />} />
            <Route path={`${env.REACT_APP_BASE_URL}/creditscore`} element={<CreditScoreDisclosure />} />
            <Route path={`${env.REACT_APP_BASE_URL}/tila-box`} element={<TilaBoxPage />} />
          </Route>
          <Route path="*" element={<Navigate to={`${env.REACT_APP_BASE_URL}`} />} />
        </Route>
      </Route>
    </Routes>
  );
};
